// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDtJWxik1gyS_7gF746ouPRyfLlEjGUgrw",
  authDomain: "techzone-1dad6.firebaseapp.com",
  projectId: "techzone-1dad6",
  storageBucket: "techzone-1dad6.appspot.com",
  messagingSenderId: "967578766111",
  appId: "1:967578766111:web:c7bb5cf829854645e07e2a",
  measurementId: "G-TJB29BQHPL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export default app;